export default "__VITE_ASSET__oVu5Iwum__"